import { useAuth } from '@/shared/hooks/useAuth';
import { useImpersonation } from '@/shared/context/useImpersonation';

/** The practice whose data the API will answer with: the impersonated one for an
 *  agency admin, else the signed-in user's own. Used to scope practice-level caches. */
export function useIvPracticeId(): string {
  const { user } = useAuth();
  const { impersonatedPractice } = useImpersonation();
  return impersonatedPractice?.id ?? user?.practiceId ?? '';
}
